module.exports = __webpack_public_path__ + "img/HomePAG313.931491a7.png";